import React, { useState, useEffect } from "react";
import "./Testimonials.css";
import TestmonyTextSection from "../Testimonalpagecontains/TestmonyTextSection";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const IMAGE_URL = "https://mithahomes.com/backend";

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(
          "https://mithahomes.com/backend/api/testimonials/all",
        );
        const data = await response.json();

        if (data.success) {
          // Filter out testimonials with null title, subtitle, or details AND where ttype is "image"
          const validTestimonials = data.data.filter(
            (testimonial) =>
              testimonial.ttitle &&
              testimonial.tsub &&
              testimonial.tdet &&
              testimonial.ttype === "image", // Added condition for ttype
          );
          setTestimonials(validTestimonials);
        } else {
          setError("Failed to fetch testimonials");
        }
      } catch (err) {
        setError("Error connecting to API: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  // Function to truncate text for preview
  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  return (
    <div className="testimonials-container">
      <div className="testimonials-header">
        <h2>TESTIMONIALS</h2>
        <p>What Our Loving Clients Are Saying</p>
      </div>

      {loading ? (
        <div className="loading">Loading testimonials...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : testimonials.length === 0 ? (
        <div className="no-testimonials">
          No image testimonials available at the moment.
        </div>
      ) : (
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.tid} className="testimonial-card">
              <div className="testimonial-header">
                <div className="avatar-container">
                  {testimonial.timg ? (
                    <img
                      src={IMAGE_URL + testimonial.timg}
                      alt={testimonial.ttitle}
                      className="avatar"
                      onError={(e) => {
                        e.target.src = `https://via.placeholder.com/50/808080/FFFFFF?text=${testimonial.ttitle ? testimonial.ttitle.charAt(0) : "U"}`;
                      }}
                    />
                  ) : (
                    <div className="avatar-placeholder">
                      {testimonial.ttitle ? testimonial.ttitle.charAt(0) : "U"}
                    </div>
                  )}
                </div>
                <div className="testimonial-info">
                  <p className="testimonial-role">{testimonial.tsub}</p>
                  <h3 className="testimonial-name">{testimonial.ttitle}</h3>
                </div>
              </div>
              <div className="testimonial-content">
                <p className="testimonial-text">
                  {truncateText(testimonial.tdet)}
                </p>
              </div>
              {testimonial.tdet && testimonial.tdet.length > 150 && (
                <a
                  href={`/testimonials/${testimonial.tid}`}
                  className="read-more"
                >
                  Read more...
                </a>
              )}
            </div>
          ))}
        </div>
      )}

      <TestmonyTextSection />
    </div>
  );
};

export default Testimonials;
